import { chainNameBySymbol } from '@frontend/utils';
import { isProductionStage } from './common';
import { ApiChainSymbolKeys, ApiChainSymbols } from './enums';

const BINANCE_PAY_NETWORK_DISPLAY_NAME = 'Binance Pay';
const WALLET_CONNECT_PAY_NETWORK_DISPLAY_NAME = 'WalletConnect Pay';

const apiChainsToTestnetChainNames: Record<ApiChainSymbolKeys, string> = {
  [ApiChainSymbols.BTC]: 'Bitcoin Testnet',
  [ApiChainSymbols.DASH]: 'Dash Testnet',
  [ApiChainSymbols.ETH]: 'Sepolia network',
  [ApiChainSymbols.BASE]: 'Base Sepolia network',
  [ApiChainSymbols.POLYGON]: 'Amoy network',
  [ApiChainSymbols.BSC]: 'BNB Smart Chain Testnet',
  [ApiChainSymbols.ERD]: 'MultiversX Devnet',
  [ApiChainSymbols.TRX]: 'Shasta network',
  [ApiChainSymbols.SUI]: 'Sui Testnet',
  [ApiChainSymbols.HEDERA]: 'Hedera Testnet',
  [ApiChainSymbols.BinancePay]: BINANCE_PAY_NETWORK_DISPLAY_NAME,
  [ApiChainSymbols.WalletConnectPay]: WALLET_CONNECT_PAY_NETWORK_DISPLAY_NAME,
  [ApiChainSymbols.MATIC]: 'Amoy network',
  [ApiChainSymbols['LN-BTC']]: 'Lightning network',
  [ApiChainSymbols.SOL]: 'Solana Pay Devnet',
  [ApiChainSymbols.SOLANA]: 'Solana Devnet',
};

export const getNetworkDisplayText = (blockchain: ApiChainSymbols) => {
  if (
    isProductionStage ||
    // We test different environments in cypress tests
    (process.env['NX_ENV'] === 'test' &&
      window.__TESTING_CONFIG__?.isProduction)
  ) {
    // We don't want to add the word "network" to "Binance Pay"
    if (blockchain === ApiChainSymbols.BinancePay) {
      return BINANCE_PAY_NETWORK_DISPLAY_NAME;
    }

    if (blockchain === ApiChainSymbols.WalletConnectPay) {
      return WALLET_CONNECT_PAY_NETWORK_DISPLAY_NAME;
    }

    if (blockchain === ApiChainSymbols.SOL) {
      return 'Solana Pay';
    }

    return `${chainNameBySymbol[blockchain]} network`;
  }

  return apiChainsToTestnetChainNames[blockchain as ApiChainSymbolKeys];
};
